import { RouteLinks } from "./router.service";
import listEquipmentWhiteIcon from "data/icons/list-equipment-white.svg";
import listEquipmentBlueIcon from "data/icons/list-equipment-blue.svg";
import listEquipmentGrayIcon from "data/icons/list-equipment-gray.svg";
import listEquipmentDarkIcon from "data/icons/list-equipment-dark-blue.svg";
import contractsWhiteIcon from "data/icons/contracts-white.svg";
import contractsBlueIcon from "data/icons/contracts-blue.svg";
import contractsGrayIcon from "data/icons/contracts-gray.svg";
import contractsDarkIcon from "data/icons/contracts-dark-blue.svg";
import casesWhiteIcon from "data/icons/cases-white.svg";
import casesBlueIcon from "data/icons/cases-blue.svg";
import casesGrayIcon from "data/icons/cases-gray.svg";
import casesDarkIcon from "data/icons/cases-dark-blue.svg";
import userManagementWhiteIcon from "data/icons/user-management-white.svg";
import userManagementBlueIcon from "data/icons/user-management-blue.svg";
import productsWhiteIcon from "data/icons/products-white.svg";
import productsBlueIcon from "data/icons/products-blue.svg";
import contractorsBlueIcon from "data/icons/contractors-blue.svg";
import contractorsWhiteIcon from "data/icons/contractors-white.svg";
import settingsBlueIcon from "data/icons/settings-blue.svg";
import settingsWhiteIcon from "data/icons/settings-white.svg";
import extensionsIcon from "data/icons/extensions2.svg";

export const formatPhoneNumber = (value: string) => {
  const numberValue = value.replace(/[^0-9]/g, "");

  if (value === "+") return "+"
  if (value === "+375 ") return "+37"
  if (value === "+37") return "+37"
  if (value === "+3") return "+3"
  if (value === "+7 ") return "+7"

  if (!numberValue) return "";

  const formatRussianNumber = (num: string) => {
    if (num.length <= 3) return `(${ num }`;
    if (num.length <= 6) return `(${ num.slice(0, 3) }) ${ num.slice(3) }`;
    if (num.length <= 8) return `(${ num.slice(0, 3) }) ${ num.slice(3, 6) }-${ num.slice(6) }`;
    return `(${ num.slice(0, 3) }) ${ num.slice(3, 6) }-${ num.slice(6, 8) }-${ num.slice(8, 10) }`;
  };

  const formatBelarusianNumber = (num: string) => {
    if (num.length <= 2) return `(${ num }`;
    if (num.length <= 5) return `(${ num.slice(0, 2) }) ${ num.slice(2) }`;
    if (num.length <= 7) return `(${ num.slice(0, 2) }) ${ num.slice(2, 5) }-${ num.slice(5) }`;
    return `(${ num.slice(0, 2) }) ${ num.slice(2, 5) }-${ num.slice(5, 7) }-${ num.slice(7, 9) }`;
  };

  if (value.startsWith("+375")) {
    const cleanNumber = numberValue.replace(/^375/, "");
    return `+375 ${ formatBelarusianNumber(cleanNumber) }`;
  }

  if (value.startsWith("+7")) {
    const cleanNumber = numberValue.replace(/^7/, "");
    return `+7 ${ formatRussianNumber(cleanNumber) }`;
  }

  if (numberValue.startsWith("375")) {
    return `+375 ${ formatBelarusianNumber(numberValue.slice(3)) }`;
  }

  if (numberValue.startsWith("7")) {
    return `+7 ${ formatRussianNumber(numberValue.slice(1)) }`;
  }

  return formatRussianNumber(numberValue);
}

export const isFuture = (date: string): boolean => {
  return new Date(+date.substring(6, 10), +date.substring(3, 5) - 1, +date.substring(0, 2)).getTime() > new Date().getTime();
}

export interface INavigationChild {
  label: string;
  link: string;
  metaKey?: string;
}

export interface INavigationItem {
  label: string;
  link: string;
  icon: string;
  blueIcon: string;
  grayIcon: string;
  darkIcon: string;
  children?: INavigationChild[];
}

export const authorizedPages: INavigationItem[] = [
  {
    label: "List of Equipment",
    link: RouteLinks.PROTECTED.LIST_EQUIPMENT,
    icon: listEquipmentWhiteIcon,
    blueIcon: listEquipmentBlueIcon,
    grayIcon: listEquipmentGrayIcon,
    darkIcon: listEquipmentDarkIcon,
  },
  {
    label: "Contracts",
    link: RouteLinks.PROTECTED.CONTRACTS_ROUTES.MAIN,
    icon: contractsWhiteIcon,
    blueIcon: contractsBlueIcon,
    grayIcon: contractsGrayIcon,
    darkIcon: contractsDarkIcon,
    children: [
      {
        label: "Invitations",
        link: RouteLinks.PROTECTED.CONTRACTS_ROUTES.INVITATION,
        metaKey: "invitations",
      },
    ],
  },
  {
    label: "Cases",
    link: RouteLinks.PROTECTED.CASES.MAIN,
    icon: casesWhiteIcon,
    blueIcon: casesBlueIcon,
    grayIcon: casesGrayIcon,
    darkIcon: casesDarkIcon,
  },
  {
    label: "Products",
    link: RouteLinks.PROTECTED.PRODUCTS,
    icon: productsWhiteIcon,
    blueIcon: productsBlueIcon,
    grayIcon: productsWhiteIcon,
    darkIcon: productsBlueIcon,
  },
  {
    label: "Contractors",
    link: RouteLinks.PROTECTED.CONTRACTORS.LIST,
    icon: contractorsWhiteIcon,
    blueIcon: contractorsBlueIcon,
    grayIcon: contractorsWhiteIcon,
    darkIcon: contractorsBlueIcon,
  },
  {
    label: "Settings",
    link: RouteLinks.PROTECTED.SETTINGS.GENERAL,
    icon: settingsWhiteIcon,
    blueIcon: settingsBlueIcon,
    grayIcon: settingsWhiteIcon,
    darkIcon: settingsBlueIcon,
    children: [
      // {
      //   label: "General",
      //   link: RouteLinks.PROTECTED.SETTINGS.MAIN,
      // },
      {
        label: "My profile",
        link: RouteLinks.PROTECTED.SETTINGS.MY_PROFILE,
      },
      {
        label: "Company details",
        link: RouteLinks.PROTECTED.SETTINGS.COMPANY_DETAILS,
      },
      {
        label: "Team",
        link: RouteLinks.PROTECTED.SETTINGS.TEAM,
      },
      {
        label: "Email Sender",
        link: RouteLinks.PROTECTED.SETTINGS.EMAIL_SENDER,
      },
    ],
  },
  {
    label: "Extensions",
    link: RouteLinks.PROTECTED.EXTENSIONS.SHARED_DRIVE,
    icon: extensionsIcon,
    blueIcon: extensionsIcon,
    grayIcon: extensionsIcon,
    darkIcon: extensionsIcon,
    children: [
      {
        label: "Shared Drive",
        link: RouteLinks.PROTECTED.EXTENSIONS.SHARED_DRIVE,
      },
    ],
  },
];

export const parseJwt = (token: string) => {
  const base64Url = token.split(".")[ 1 ];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function(c) {
    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(""));

  return JSON.parse(jsonPayload);
}

export const getClientRoleTitle = (role: "provider_admin" | "provider_staff" | "provider_engineer" | "customer_admin" | "customer_user"): string => {
  switch (role) {
    case "provider_admin":
      return "Provider Admin"
    case "provider_staff":
      return "Provider Staff"
    case "provider_engineer":
      return "Provider Engineer"
    case "customer_admin":
      return "Customer Admin"
    case "customer_user":
      return "Customer User"
    default:
      return "-/-"
  }
}

export const formatDateForApi = (date: string): string => {
  return date === "" || date === null ? "" : `${ new Date(date).getFullYear() }-${ formatDateItem(new Date(date).getMonth() + 1) }-${ formatDateItem(new Date(date).getDate()) }`
}

export const formatDateItem = (item: number): string => {
  return item < 10 ? `0${ item }` : item.toString();
}

export const downloadFromLink = (link: string) => {
  window.open(link);
}

export const extraPortion = 50;
export const extraLimit = 500;
